/** @flow */

import type { HierarchyChangelogState } from "@modules/hierarchy/reducer/change-log/types";
import { startRequest, finishRequest } from "@store/utils";

export type ChangeLogState = {
  error: ?Object | ?string,
  changelog: HierarchyChangelogState,
};

export const startLoading = (state: ChangeLogState) => () => {
  return {
    ...state,
    changelog: {
      ...startRequest(state.changelog),
    },
  };
};

export const finishLoading = (state: ChangeLogState) => () => {
  return {
    ...state,
    changelog: {
      ...finishRequest(state.changelog),
    },
  };
};

export const onGetHierarchyChangelogSuccess = (state: ChangeLogState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    changelog: {
      ...finishRequest(state.changelog),
      list: payload,
    },
  };
};

export const onGetHierarchyChangelogUsersSuccess = (state: ChangeLogState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: null,
    changelog: {
      ...finishRequest(state.changelog),
      users: payload,
    },
  };
};

export const onChangelogError = (state: ChangeLogState) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    changelog: {
      ...finishRequest(state.changelog),
    },
  };
};
